const getKnitVariations = (commonCanopies, commonVariaton) => {

	return {
		'7450': {
			...commonVariaton,
			size: {
				width: 0.45,
				height: 0.40,
				depth: 0.45
			},
			paddingTop: -0.35,
			familyName: 'flat',
			related: ['7450', '7455', '7460', '7470', '7475'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
        '7455': {
			...commonVariaton,
			size: {
				width: 0.45,
				height: 0.26,
				depth: 0.45
			},
			paddingTop: -0.35,
			familyName: 'flat',
			related: ['7450', '7455', '7460', '7470', '7475'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
        '7460': {
			...commonVariaton,
			size: {
				width: 0.45,
				height: 0.32,
				depth: 0.45
			},
			paddingTop: -0.35,
			familyName: 'flat',
			related: ['7450', '7455', '7460', '7470', '7475'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
        '7470': {
			...commonVariaton,
			size: {
				width: 0.65,
				height: 0.35,
				depth: 0.65
			},
			paddingTop: -0.35,
			familyName: 'flat',
			related: ['7450', '7455', '7460', '7470', '7475'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
        '7475': {
			...commonVariaton,
			size: {
				width: 0.65,
				height: 0.49,
				depth: 0.65
			},
			paddingTop: -0.35,
			familyName: 'flat',
			related: ['7450', '7455', '7460', '7470', '7475'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		}
	}
}

export default getKnitVariations